import React, { useState, useEffect, useRef } from 'react';
import WaitlistModal from '../WaitlistModal/WaitlistModal';
import HeroSection from './HeroSection';
import WhySection from './WhySection';
import WhatSection from './WhatSection';
import LeadershipSection from './LeadershipSection';
import ProductsSection from './ProductsSection';
import FooterSection from './FooterSection';
import Footer from '../Footer/Footer';
import NavbarComponent from './Navbar';
import './LandingPage.css';
import { useNavigate, useLocation } from 'react-router-dom';

const LandingPage = ({ messages = [], // Provide default empty array 
  loading,
  isStreaming,
  onSendMessage, 
  currentBotId, 
  currentScreenId,
  onSwitchBot,
  screens}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [activeLink, setActiveLink] = useState('');
  const scrollListenerActive = useRef(true);
  const [scrolled, setScrolled] = useState(false);
  const [showWaitlistModal, setShowWaitlistModal] = useState(false);
  const [isInvestorInquiry, setIsInvestorInquiry] = useState(false);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [navExpanded, setNavExpanded] = useState(false);
  const [isNavigating, setIsNavigating] = useState(false);

  // Check if there are messages
  const hasMessages = messages && messages.length > 0;

  const showKlaviyoForm = () => {
    setIsInvestorInquiry(false);
    setShowWaitlistModal(true);
  };

  const showInvestorInquiryForm = () => {
    setIsInvestorInquiry(true);
    setShowWaitlistModal(true);
  };

  useEffect(() => {
    const hash = window.location.hash || '#home';
    setActiveLink(hash);

    const handleScroll = () => {
      if (window.scrollY > 50) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
      
      if (!scrollListenerActive.current) return;
    
      const sections = ['home', 'why', 'what', 'leadership', 'products'];
      let found = false;
      for (let i = 0; i < sections.length; i++) {
        const el = document.getElementById(sections[i]);
        if (el) {
          const rect = el.getBoundingClientRect();
          if (rect.top <= window.innerHeight / 3 && rect.bottom >= window.innerHeight / 3 ) {
            setActiveLink(`#${sections[i]}`);
            found = true;
            break;
          }
        }
      }
      if (!found) setActiveLink('#home');

    };

    window.addEventListener('scroll', handleScroll);
    handleScroll();

    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Reset loading when route changes
  useEffect(() => {
    setIsNavigating(false);
  }, [location.pathname]);

  // Handler for login navigation
  const handleLoginNavigate = () => {
    setIsNavigating(true);
    navigate('/chat');
  };

  const handleNavClick = (hash) => {
    setActiveLink(hash);
    scrollListenerActive.current = false;
    setTimeout(() => {
      scrollListenerActive.current = true;
    }, 1000);
    if (windowWidth <= 991) setNavExpanded(false);
  };

  return (
    <div className="landing-page">
      {isNavigating && (
        <div className="loading-overlay">
          <div className="spinner"></div>
          <div className="loading-text">Loading...</div>
        </div>
      )}
      <div className={`${hasMessages ? 'hero-top-section-white' : 'hero-top-section'}`} >
        <NavbarComponent 
          onNavigateToLogin={handleLoginNavigate}
          setShowWaitlistModal={setShowWaitlistModal}
          hasMessages={!hasMessages}
        />
        <HeroSection
          messages={messages}
          loading={loading}
          isStreaming={isStreaming}
          onSendMessage={onSendMessage}
          currentBotId={currentBotId}
          currentScreenId={currentScreenId}
          onSwitchBot={onSwitchBot}
          screens={screens}
          style={{ height: '90vh' }}
        />
      </div>
      <WhySection />
      <WhatSection windowWidth={windowWidth}/>
      <LeadershipSection />
      <div id="products">
        <ProductsSection 
          showKlaviyoForm={showKlaviyoForm} 
          showInvestorInquiryForm={showInvestorInquiryForm}
          onNavigateToLogin={handleLoginNavigate} 
        />
        <FooterSection />
        <Footer />
      </div>
      <WaitlistModal 
        show={showWaitlistModal} 
        onHide={() => setShowWaitlistModal(false)} 
        isInvestorInquiry={isInvestorInquiry}
      />
      {/* <div className="scroll-indicator-vertical">
        <div className="scroll-dots">
          {['#home','#why','#what','#leadership','#products'].map((i, idx) => {
            const isActive = activeLink === i;
            return (
              <div
                key={i}
                className="dot"
                style={{
                  height: isActive ? 110 : 8,
                  borderRadius: isActive ? 6 : '50%',
                  opacity: isActive ? 1 : 0.7,
                  background: '#D9D9D9',
                  width: 8,
                  margin: '2px 0',
                  transition: 'height 0.4s cubic-bezier(0.4,0,0.2,1), border-radius 0.4s cubic-bezier(0.4,0,0.2,1), opacity 0.3s',
                }}
              />
            );
          })}
        </div>
      </div> */}
    </div>
  );
};

export default LandingPage; 